export const NAME = 'debts';
